import React, {forwardRef, useEffect, useRef, useState} from "react";
import {
    EVENT_REFRESH_SLIDER_INFO,
    getElementSelectionBorderColor,
    INFO_NOTES_EXTRA_HEIGHT, MAX_NOTES_HEIGHT
} from "../../../../../src/Const";
import {mutateElement} from "../../element/mutateElement";
import {postMessage} from "../../../../../src/common/event";
import {getCardById, updateCard} from "../../../../../model";
import {generateUUID2, isAudioFileElement} from "../../../../../src/utils";
import i18next from "i18next";
import {isEmbedableBookmarkElement, isEmbeddableElement, isImageElement} from "../../element/typeChecks";
import Global from "../../../../../src/global";

const RenderCanvasNote = forwardRef((props:{el:any,state:any,app:any,onWheel:any,onTextChange?:any,isVisible:any}, ref) => {
    const {el} = props;

    const [inputValue,setInputValue] = useState('');
    const selfGuid = useRef('');
    const inputRef = useRef(null);


    useEffect(()=>{
        getCardById(el.customData?.generationData?.id).then(res=>{
            if (res){
                const customData = {...el.customData};
                customData.generationData.infoNotes = res.infoNotes;
                // customData.generationData.isEditable = false;
                setInputValue(res.infoNotes);
                setTimeout(()=>{
                    if (inputRef.current){
                        let nHeight = inputRef.current.scrollHeight;
                        if (nHeight > MAX_NOTES_HEIGHT){
                            nHeight = MAX_NOTES_HEIGHT;
                        }
                        if (nHeight != 0){
                            customData.generationData.inputHeight = nHeight;//高度
                        }
                    }
                    mutateElement(el,{customData})
                },10)
            }else{
                setInputValue(el.customData?.generationData?.infoNotes);
            }
        })

        selfGuid.current = generateUUID2();



    },[])

    useEffect(() => {
        if (props.isVisible){
            //重新算一遍高度。要兼容之前的大字体的
            reCalcHeightAndUpdate(true);
        }
    }, [props.isVisible,props.el.width,props.el.height]);

    useEffect(() => {
        window.refreshList['refreshRenderCanvasNote_'+el.id] = (data,extra)=>{
            if (!data)return;
            if (data.id && data.id == el.customData?.generationData?.id && extra?.guid != selfGuid.current){
                setInputValue(data.infoNotes);

                const customData = {...el.customData};
                customData.generationData.infoNotes = data.infoNotes;
                //重新计算高度....
                if (inputRef.current){
                    let nHeight = inputRef.current.scrollHeight;
                    if (nHeight > MAX_NOTES_HEIGHT){
                        nHeight = MAX_NOTES_HEIGHT;
                    }
                    customData.generationData.inputHeight = nHeight;//高度
                }
                const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
                mutateElement(el0,{customData:customData})
            }
        }

        return ()=>{
            delete window.refreshList['refreshRenderCanvasNote_'+el.id];
        }
    }, [el]);

    useEffect(() => {
        if (el.customData?.generationData?.isEditable){
            setTimeout(()=>{
                inputRef.current?.focus();
                // inputRef.current?.setSelectionRange(0,0);
            },200)
        }
    }, [el.customData?.generationData?.isEditable]);

    useEffect(() => {
        if (el.customData?.generationData?.isShowInfoNotes){
            reCalcHeightAndUpdate();
        }
    }, [el.customData?.generationData?.isShowInfoNotes]);

    const reCalcHeightAndUpdate = (isResetHeight = false)=>{
        //重新计算高度....
        const customData = {...el.customData};
        // customData.generationData.isEditable = false;
        if (el.customData?.generationData?.isShowInfoNotes && isResetHeight){
            if (inputRef.current){
                inputRef.current.style.height = '0px';
            }
        }

        if (inputRef.current){
            //直接2遍
            let nHeight = inputRef.current.scrollHeight;
            if (nHeight > MAX_NOTES_HEIGHT){
                nHeight = MAX_NOTES_HEIGHT;
            }
            if (nHeight != 0){
                customData.generationData.inputHeight = nHeight;//高度
            }
            if (el.customData?.generationData?.isShowInfoNotes && isResetHeight){
                inputRef.current.style.height = `${nHeight}px`;
                //test
                const newHeight = el.customData.generationData.originHeight + nHeight + INFO_NOTES_EXTRA_HEIGHT;
                const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
                Global.g_mapElementHeight[props.el.id] = newHeight;
                mutateElement(el0,{customData:customData,height:newHeight});
            }
            const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
            mutateElement(el0,{customData})
        }

        {
            setTimeout(()=>{
                if (inputRef.current){
                    let nHeight = inputRef.current.scrollHeight;
                    if (nHeight > MAX_NOTES_HEIGHT){
                        nHeight = MAX_NOTES_HEIGHT;
                    }
                    if (nHeight != 0){
                        customData.generationData.inputHeight = nHeight;//高度
                    }
                    if (el.customData?.generationData?.isShowInfoNotes && isResetHeight){
                        inputRef.current.style.height = `${nHeight}px`;
                        //test
                        const newHeight = el.customData.generationData.originHeight + nHeight + INFO_NOTES_EXTRA_HEIGHT;
                        const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
                        Global.g_mapElementHeight[props.el.id] = newHeight;
                        mutateElement(el0,{customData:customData,height:newHeight});
                    }
                }
                const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
                mutateElement(el0,{customData})
            },50)
        }
    }

    const onSelectElement = ()=>{
        props.app.setState({
            selectedElementIds:{[el.id]:true}
        })
    }


    return <>
        {
            (isEmbedableBookmarkElement(el) || isAudioFileElement(el)) &&
            <div className={'line'}></div>
        }
        <textarea ref={inputRef} id={`txt-input-note-${el.id}`} placeholder={i18next.t("AddACaption")}
                  value={inputValue}
                  readOnly={el.customData?.generationData?.isEditable == false}
                  className={'textarea-note'}
                  onDoubleClick={(event) => {
                      const customData = {...el.customData};
                      customData.generationData.isEditable = true;
                      mutateElement(el, {customData: customData})
                      //要选中这个.
                      onSelectElement();
                  }} onClick={(event) => {
            onSelectElement();
            postMessage(EVENT_REFRESH_SLIDER_INFO)
        }}
                  onWheel={(e)=>{
                      if (document.activeElement?.id?.includes('txt-input-note-')){

                      }else{
                          props.onWheel(e);
                      }
                  }}
                  style={{
                      pointerEvents: 'all',
                      marginTop: (isAudioFileElement(el) || isEmbeddableElement(el))?'10px':'6px',
                      marginBottom: '0px',
                      fontSize:'16px',
                      maxHeight:`${MAX_NOTES_HEIGHT}px`,
                      height: `${el.customData?.generationData?.inputHeight}px`,
                      display:(el.customData?.generationData?.isShowInfoNotes ? '' : 'none'),
                      cursor: el.customData?.generationData?.isEditable == false ? 'default' : 'inherit',
                  }} onChange={(event) => {
            event.currentTarget.style.height = '0px';
            let nHeight = event.currentTarget.scrollHeight;
            if (nHeight > MAX_NOTES_HEIGHT){
                nHeight = MAX_NOTES_HEIGHT;
            }

            event.currentTarget.style.height = nHeight + 'px';
            if (!el.customData?.generationData) {
                el.customData = {
                    generationData: {originHeight:el.height}
                }
            }

            setInputValue(event.currentTarget.value);
            const customData = {...el.customData};
            customData.generationData.infoNotes = event.currentTarget.value;
            customData.generationData.inputHeight = nHeight;//高度

            el.customData.generationData.infoNotes = event.currentTarget.value;
            el.customData.generationData.inputHeight = nHeight;//高度
            // if (!customData?.generationData?.id){//新建的时候，embed有可能没有id
            //     customData.generationData.id = generateUUID2();
            // }

            window.globalRefreshList('refreshLibraryInfos_', el.customData.generationData);
            //刷新同画布的别的同一个infonotes
            window.globalRefreshList('refreshRenderCanvasNote_', el.customData.generationData, {guid: selfGuid.current})

            //SHIT一样的东西，必须得重新找一下更新，才能更新---  React的机制真TM难用。
            const el0 = props.app.getSceneElements().find(p=>p.id == el.id);
            const newHeight = el.customData.generationData.originHeight + nHeight + INFO_NOTES_EXTRA_HEIGHT;
            mutateElement(el0,{customData:customData,height:newHeight});

        }} onBlur={(event) => {
            const customData = {...el.customData};
            customData.generationData.isEditable = false;

            //更新到库.
            getCardById(el.customData?.generationData?.id).then(res => {
                if (res) {
                    res.infoNotes = el.customData.generationData.infoNotes;
                    updateCard(res).then(r=>{
                        //刷新左侧栏目。。。--有些显示notes,有些显示title  -- 直接刷新。
                        window.onRefreshSingleElement(el);
                    });
                }else{
                    //刷新左侧栏目。。。
                    window.onRefreshSingleElement(el);
                }
            })
        }} onFocus={(e)=>{
            delete Global.g_mapElementHeight[props.el.id]
        }}/>
    </>
})

export default RenderCanvasNote;